import { render } from "./CrawlTrivia.vue?vue&type=template&id=f4975906&scoped=true"
import script from "./CrawlTrivia.vue?vue&type=script&lang=js"
export * from "./CrawlTrivia.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f4975906"

export default script